export const ApplySourceType = {
    Map: new Map<string, string>([
        ['01', 'VMS_VISIT_REQUEST_APPLY_SOURCE_TYPE_EMPLOYEE_WEB'],
        ['02', 'VMS_VISIT_REQUEST_APPLY_SOURCE_TYPE_EMPLOYEE_APPLET'],
        ['03', 'VMS_VISIT_REQUEST_APPLY_SOURCE_TYPE_VISITOR_APPLET'],
        ['04', 'VMS_VISIT_REQUEST_APPLY_SOURCE_TYPE_MANAGER_WEB'],
        ['05', 'VMS_VISIT_REQUEST_APPLY_SOURCE_TYPE_VISITOR_MOBILE_WEB'],
    ]),
    Enum: {
        EmployeeWeb: "01",
        EmployeeApplet: "02",
        VisitorApplet: '03',
        ManagerWeb: "04",
        VisitorMobileWeb: '05',
    }
};